export default __webpack_public_path__ + "img/dde3ae499b46ecad9c9fc849fc87d8ac.jpg";